module.exports = __webpack_public_path__ + "media/images/favicons/favicon-3b77703b85da51e791b00e4021a2d4e9.ico";